import { render, staticRenderFns } from "./DispatcherReviewAcceptModal.vue?vue&type=template&id=5fd06a31&scoped=true&"
import script from "./DispatcherReviewAcceptModal.vue?vue&type=script&lang=js&"
export * from "./DispatcherReviewAcceptModal.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherReviewAcceptModal.vue?vue&type=style&index=0&id=5fd06a31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd06a31",
  null
  
)

export default component.exports